import React, { useState } from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import Dropdown from "../ui/Dropdown";
//import { setCabinetGLBFromCabinetsSet } from "../../helpers/sqft3dArHelper";
import {setSquareFootageGroup} from "../../../../actions/sqftFunctions";
import {SQFT_GROUP_DROPDOWN} from "../../constants";
import {setSQFTActiveLevel3Button} from "../../../../actions/sqftMenuFunctions";
import {setGroheFiltersSearchText} from "../../../../actions/groheFunctions";
import {clearAllMenusEvents} from "../canvas/core/workspace/workspaceEvents";
import {withRouter} from "react-router-dom";
import {hashHistory} from "react-router";
import {isSFTCabinetsGroup} from "../../helpers/sqftNavigationHelper";

const GroupDropdown = (props) => {
  const { setSquareFootageGroup } = props;
  const items = [
    { label: "Countertop", value: SQFT_GROUP_DROPDOWN.countertop },
    { label: "Cabinets", value: SQFT_GROUP_DROPDOWN.cabinets },
  ];
  const [activeItem, setActiveItem] = useState(isSFTCabinetsGroup() ? items[1] : items[0]);

  const handleItemSelect = async (item) => {
    clearAllMenusEvents();
    setActiveItem(item);

    setSquareFootageGroup(item.value);
    hashHistory.push("sqft?group=" + item.value);
  };

  const handleDropdownSelect = async (prevIsOpen) => {
    void prevIsOpen;
    setSQFTActiveLevel3Button(null);
    setGroheFiltersSearchText("");
  };

  return (
    <Dropdown
      className={"dropdown-mode ui-select"}
      items={items}
      activeItem={activeItem}
      onItemSelect={handleItemSelect}
      onDropdownSelect={handleDropdownSelect}
      isOpenInitially={false}
    />
  );
};

const mapStateToProps = (store) => ({
  SQFTGroup: store.sqftState.SQFTGroup,
});

const mapDispatchToProps = {
  setSquareFootageGroup,
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(GroupDropdown)
  )
);
